import React, { useState, useEffect } from 'react';
import SideMenu from "../../common/SideMenu";
import DashboardNav from "../component/DashboardNav";

const BudgetYear = () => {
  const [year, setYear] = useState('');
  const [inputYear, setInputYear] = useState('');
  const [inputText, setInputText] = useState('');
  const [inputYearLabel, setInputYearLabel] = useState('Year');  // Dynamic Year Label
  const [message, setMessage] = useState('');

  const title = "Budget Year";

  useEffect(() => {
    const storedYear = localStorage.getItem('budgetYear');
    const storedText = localStorage.getItem('budgetText');
    const storedYearLabel = localStorage.getItem('budgetYearLabel');
    
    if (storedYear) {
      setYear(storedYear);
      setInputYear(storedYear);
    } else {
      const currentYear = new Date().getFullYear();
      setYear(currentYear);
      setInputYear(currentYear);
      localStorage.setItem('budgetYear', currentYear);
    }

    if (storedText) {
      setInputText(storedText);
    } else {
      setInputText("Lagos State Comprehensive Budget");  // Default text
      localStorage.setItem('budgetText', "Lagos State Comprehensive Budget");
    }

    if (storedYearLabel) {
      setInputYearLabel(storedYearLabel);  // Retrieve the custom label for 'Year'
    }
  }, []);



  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputYear || isNaN(inputYear)) {
      setMessage('❌ Please enter a valid year');
      return;
    }
    localStorage.setItem('budgetYear', inputYear);
    localStorage.setItem('budgetText', inputText);
    localStorage.setItem('budgetYearLabel', inputYearLabel);  // Store the dynamic label
    setYear(inputYear);
    setMessage(`✅ Budget updated: ${inputYearLabel} ${inputYear} - ${inputText}`);
  };

  return (
    <div className="member body">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2">
                    <SideMenu />
                </div>
                <div className="col-md-10">
                    <DashboardNav page={title} />
                    <div>
                        <div className="__house">
                            <div className="__btcard">
                                <div className="__btcardin">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-3"></div>
                                        <div className="col-lg-6 col-md-6 col-sm-6">
                                            <p className="__btp">Current Budget Year: <strong>{year}</strong></p>
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-group">
                                                    <label className="__modlab">Year Label (e.g., "Fiscal Year"):</label>
                                                    <input 
                                                        type="text"
                                                        value={inputYearLabel}
                                                        onChange={(e) => setInputYearLabel(e.target.value)}
                                                        className="form-control __regdivform"
                                                    />
                                                </div><br/>
                                                <div className="form-group">
                                                    <label className="__modlab">New Budget Year:</label>
                                                    <input 
                                                        type="number"
                                                        value={inputYear}
                                                        onChange={(e) => setInputYear(e.target.value)}
                                                        className="form-control __regdivform" 
                                                    />
                                                </div><br/>
                                                <div className="form-group">
                                                    <label className="__modlab">New Budget Text:</label>
                                                    <input 
                                                        type="text"
                                                        value={inputText}
                                                        onChange={(e) => setInputText(e.target.value)}
                                                        className="form-control __regdivform"
                                                    />
                                                </div><br/>
                                                <button type="submit" className="btn btn-block __autbtn">Update</button>
                                            </form>
                                            {message && <p style={{ marginTop: '1rem' }}>{message}</p>}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="__spacet7p"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default BudgetYear;
